import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { MANAGED_MAILBOX_CATALOGS } from "./model/managed-mailbox-copy.ts";
import { MANAGED_MAILBOX_ERROR_COPY } from "./model/managed-mailbox-error-copy.ts";
import { MANAGED_MAILBOX_PURCHASE_CATALOGS } from "./model/managed-mailbox-purchase-copy.ts";

const wizard = () => import("./ui/sections/purchase-screen.tsx");

// D206 (ADR-006 §7): every screen needs "outreach"; off, each one is the not-found screen,
// so buying domains and mailboxes does not exist for the organization.
export const managedMailboxBrowserModule: BrowserModule = defineBrowserModule("managed-mailbox")
  .withErrorCopy(MANAGED_MAILBOX_ERROR_COPY)
  .withScreens({
    purchase: {
      path: "/managed-mailboxes",
      title: phrase(MANAGED_MAILBOX_PURCHASE_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "outreach",
      load: wizard,
    },
    // The reference keeps its pre-rename routes alive; so do we.
    legacy: {
      path: "/managed-mailbox",
      title: phrase(MANAGED_MAILBOX_PURCHASE_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "outreach",
      load: wizard,
    },
    domains: {
      path: "/managed-mailboxes/domains",
      title: phrase(MANAGED_MAILBOX_CATALOGS, "titleDomains"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/domains-screen.tsx"),
    },
    mailboxes: {
      path: "/managed-mailboxes/mailboxes",
      title: phrase(MANAGED_MAILBOX_CATALOGS, "titleMailboxes"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/mailboxes-screen.tsx"),
    },
    orders: {
      path: "/managed-mailboxes/orders",
      title: phrase(MANAGED_MAILBOX_CATALOGS, "titleOrders"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/orders-screen.tsx"),
    },
    order: {
      path: "/managed-mailboxes/orders/:orderId",
      title: phrase(MANAGED_MAILBOX_CATALOGS, "titleOrder"),
      layout: "app",
      flag: "outreach",
      load: () => import("./ui/sections/order-screen.tsx"),
    },
  });
